import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { Collections } from '@graylog/enterprise-api';

import type { CollectionGrantees } from 'collections/types';
import { defaultOnError } from 'util/conditional/onError';

const INITIAL_DATA = {
  list: [],
};

export const COLLECTION_GRANTEES_QUERY_KEY = 'collection_grantees';

export const keyFn = (entityGRN: string) => [COLLECTION_GRANTEES_QUERY_KEY, entityGRN];

const fetchCollectionGrantees = async (entityGRN: string) =>
  Collections.getCollectionSharing(entityGRN).then((responseArray) => ({
    list: responseArray,
  }));

const useCollectionGrantees = (
  entityGRN: string,
  { enabled } = { enabled: true },
): {
  data: {
    list: CollectionGrantees;
  };
  isLoading: boolean;
  refetch: () => void;
} => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: keyFn(entityGRN),
    queryFn: () =>
      defaultOnError(
        fetchCollectionGrantees(entityGRN),
        'Loading Collection Grantees failed with status',
        'Could not load Collection Grantees',
      ),
    placeholderData: keepPreviousData,
    enabled,
  });

  return {
    data: data ?? INITIAL_DATA,
    isLoading,
    refetch,
  };
};

export default useCollectionGrantees;
